import React, { useState, useEffect } from 'react';
import fetchFacebookMetrics from '../cards/RhythmCard/fetchFacebookMetrics'; // Import the Facebook metrics function
import FacebookLoginButton from './FacebookLoginButton';




const FacebookPostsWidget = () => {
  const [postsCount, setPostsCount] = useState(0); // State to store the total number of posts

  const handleLoginSuccess = async (accessToken) => {
    const { fieldsPosts } = await fetchFacebookMetrics(accessToken); // Fetch metrics using the token
    setPostsCount(fieldsPosts.length); // Set the post count
  };

  // // Fetch Facebook metrics when the component mounts
  // useEffect(() => {
  //   const getFacebookMetrics = async () => {
  //     const { posts } = await fetchFacebookMetrics(); // Fetch the posts
  //     setPostsCount(posts.length); // Set the posts count
  //   };
    
  //   getFacebookMetrics(); // Call the async function
  // }, []); // Empty dependency array to run only once when the component mounts

  return (
    <div>
      <FacebookLoginButton onLoginSuccess={handleLoginSuccess} />
      <div>
        <div className="mb-2">Facebook Posts</div>
        <strong>{postsCount} posts</strong>
      </div>
    </div>
  );
};

export default FacebookPostsWidget;


